import React from 'react'

const Form = ({ error, handleSubmit, className, children }) => (
	<form className={className} onSubmit={handleSubmit}>
		{children}
	</form>
)

export default Form